jQuery(document).ready(function() {
    // edit plan size steps transition
    jQuery('#editPlanSize').on('click', function(e) {

        if( e.currentTarget.hasAttribute('tooltip') )
        {
            alert( e.currentTarget.getAttribute('tooltip') );
        }
        else
        {
            jQuery('#subscriptionSettingsMain').hide();
            jQuery('#footer').hide();
            jQuery('.edit-plan-size').show();

            let currentPlan = jQuery('input[name="crateSize"]').val();
            jQuery(`.option-interaction.card-size[data-sizecode="${currentPlan}"]`).click();

            let currentTerm = jQuery('input[name="term"]').val();
            jQuery(`.term-select[value=${currentTerm}]`).click();
        }
    })

    jQuery('#backBtnSize').on('click', function(e) {
        jQuery('.edit-plan-size').hide();
        jQuery('#subscriptionSettingsMain').show();
        jQuery('#footer').show();
    })

    jQuery('#backBtnDrink').on('click', function(e) {
        jQuery('.edit-plan-drink').hide();
        jQuery('.edit-plan-size').show();
    })

    jQuery('#editPlanFlavors').on('click', function(e) {
        jQuery('#subscriptionSettingsMain').hide();
        jQuery('#footer').hide();
        jQuery('.edit-plan-flavors').show();
    })

    jQuery('#backBtnFlavors').on('click', function(e) {
        jQuery('.edit-plan-flavors').hide();
        jQuery('#subscriptionSettingsMain').show();
        jQuery('#footer').show();
    })

    // when user submits edit plan size form
    jQuery('#nextBtnSize').on('click', function(e) {
        jQuery('.edit-plan-size').hide();
        jQuery('.edit-plan-drink').show();

        let sizeCode = jQuery('.card-size.active').data('sizecode');
        let term = jQuery(`input[name=${sizeCode}-options]:checked`).val();

        jQuery("input[name='crateSize']").val(sizeCode);
        jQuery("input[name='term']").val(term);
    })

    // when user submits edit plan drink form
    jQuery('#nextBtnDrink').on('click', function(e) {
        jQuery('.edit-plan-drink').hide();
        jQuery('#subscriptionSettingsMain').show();
        jQuery('#footer').show();
    })

    // pick a size animation / toggle
    jQuery('.card-size').on('click', function(e) {

        e.preventDefault();
        let selectedSize = e.currentTarget.dataset.sizename;

        jQuery('.card-size').removeClass('active');
        jQuery(this).toggleClass('active');

        jQuery('.card-size-mobile').addClass('d-none');
        jQuery(`.card-${selectedSize}-mobile`).toggleClass('d-none');
        
        if( ['US','CA','UK','GB'].includes(jQuery("#editPlanSizeWrap").data('countrycode')) )
        {
            jQuery('.card-months').addClass('hide').removeClass('show');
            jQuery(`.card-months-${selectedSize}`).removeClass('hide').addClass('show');
            /*
            jQuery('body,html').animate({
                scrollTop: jQuery(`#card-hug-${selectedSize}`).offset().top - 90
            }, 400);
            */
        }
        else
        {
            let uglySizes = {
                'Mini': '4Snack',
                'Original': '8Snack',
                'Family': '16Snack',
            };
            jQuery(`.card-months-${selectedSize} input[name="${uglySizes[selectedSize]}-options"][value=1]`).click();
        }
    });

    // move months selectors on edit-plan-size based on browser width
    if(jQuery('body').hasClass('subscription-settings') || jQuery('body').hasClass('new-subscription')) {
        const sizes = ['Mini', 'Original', 'Family'];

        for ( let i = 0; i < sizes.length; i++ ) {
            const monthSelector = jQuery(`.card-${sizes[i]}-mobile`);
            const monthSelectorsMobile = jQuery(`#monthSelectorsMobile${sizes[i]}`);
            const monthSelectorsDesktop = jQuery(`#monthSelectorsDesktop${sizes[i]}`);

            if (jQuery(window).width() < 576) {
                jQuery(monthSelector).insertAfter(monthSelectorsMobile);
            } else {
                jQuery(monthSelector).insertAfter(monthSelectorsDesktop);
            }
    
            jQuery(window).on('resize', function() {
                if (jQuery(window).width() < 576) {
                    jQuery(monthSelector).insertAfter(monthSelectorsMobile);
                } else {
                    jQuery(monthSelector).insertAfter(monthSelectorsDesktop);
                }
            });    
        }  
    }

    // edit plan drink button toggle
    // when user clicks 'Add Drink Upgrade +'
    jQuery('#editPlanAddDrink').on('click', function(e) {
        jQuery('#editPlanAddDrink').hide();
        jQuery('.remove-drink-container').removeClass('d-none').addClass('d-flex');

        jQuery('#removeDrinkContainer').removeClass('d-none');
        jQuery('#addDrinkContainer').addClass('d-none');

        jQuery("input[name='has_drink']").val(1);
    })

    // when user clicks 'Remove Drink Upgrade'
    jQuery('#editPlanRemoveDrink').on('click', function(e) {
        jQuery('.remove-drink-container').removeClass('d-flex').addClass('d-none');
        jQuery('#editPlanAddDrink').show();

        jQuery('#addDrinkContainer').removeClass('d-none');
        jQuery('#removeDrinkContainer').addClass('d-none');

        jQuery("input[name='has_drink']").val(0);
    })

    // flavor selection animation / toggle
    jQuery('.card-flavor').on('click', function(e) {
        e.preventDefault();
        jQuery('.card-flavor').removeClass('active');
        jQuery(this).toggleClass('active');
        jQuery("input[name='flavorPreference']").val( e.currentTarget.dataset.flavor );
    });
});